import { Component, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { LeadEngineerService } from '../../../services/leadengineer.service';
import { NgIf, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { MessageModule } from 'primeng/message';
import { TableModule } from 'primeng/table';

@Component({
    selector: 'app-lead-engineer-installed-save',
    imports: [TableModule, DropdownModule, FormsModule, NgIf, NgClass, MessageModule],
    templateUrl: './lead-engineer-installed-save.component.html',
    styleUrl: './lead-engineer-installed-save.component.scss'
})
export class LeadEngineerInstalledSaveComponent {
    loading: boolean = false;
    installedData: any[] = [];
    filterdInstalledData: any[] = [];
    dropDownData: any[] = [];
    selectedDivision: any = '';
    @Input() setData: any;
    constructor(private leadEngineerService: LeadEngineerService,private router: Router){
  
    }
  
  
    ngOnChanges(changes: SimpleChanges): void {
      // This lifecycle hook is called whenever an input property changes
  
      this.loading  = true;
      if (changes['setData']) {
        if (this.setData) {
          this.processLEData();
        }
      }
    }
  
    processLEData(){
      this.installedData = this.setData.tblEngrWithCAI_Installed;
      this.installedData.map((item: any) => {
        if (item.tlr_status === 'I') {
          item.status = 'Installed';
          item.cssClass = 'green'
        } else if (item.tlr_status === 'P') {
          item.status = 'Pre Installation';
          item.cssClass = 'blue'
        } else if (item.tlr_status === 'R') {
          item.status = 'Removed';
          item.cssClass = 'red'
        }
      })
      if(this.setData.Division_I) {
        this.dropDownData = this.setData.Division_I.map((item: any) => {
          return { label: item, value: item };
        });
      }
      this.selectedDivision = this.dropDownData[0].value;
      this.filterInstalledData();
    }
  
    details(row: any){
      this.router.navigate(['/details-section', row.tag_number]);
    }
  
    assignToMe(row : any){
      localStorage.setItem('oA_action_type', 'Insert');
      this.router.navigate(['/oa-compliance-details-section', row.tag_number]);
  
    }
    onDivisionChange(){
      this.filterInstalledData();
    }
  
    filterInstalledData( ){
       this.filterdInstalledData = this.installedData.filter((item: any) => {
        return item.division_name === this.selectedDivision;
      });
      this.loading = false;
    }

    editTle(row : any){
    this.router.navigate(['/leadEngineer-compliance-details-section', row.tag_number]);

    }

  
}
